/**
 * Created by mac on 5/8/17.
 */

class PseudoRandom {
    constructor(channel) {
        this.state = 0;

        this.m = 0x80000000; // 2**31;
        this.a = 1103515245;
        this.c = 12345;

        this.channel = channel;

        if (channel === undefined) {
            this.randomSeed();
        } else {
            this.seed(channel);
        }
    }

    static GET(channel) {
        if (!PseudoRandom.CHANNELS.has(channel)) {
            PseudoRandom.CHANNELS.set(channel, new PseudoRandom(channel));
        }

        return PseudoRandom.CHANNELS.get(channel);
    }

    seed(seed) {
        if (typeof seed === "number") {
            this.state = Math.abs(parseInt(seed) || 0) % this.m;
            return this.state;
        }

        if (typeof seed === "string") {
            return this.seed(cleverapps.hashCode(seed));
        }

        cleverapps.throwAsync("Expecting string as seed");
    }

    randomSeed() {
        this.state = Math.floor(Math.random() * this.m);
        const state = this.state;
        const loop = [];
        for (let i = 0; i < 100; i++) {
            const x = this.nextInt();
            if (loop.indexOf(x) >= 0) {
                this.randomSeed();
                return;
            }
            loop.push(x);
        }
        this.state = state;
    }

    shuffle(arr, seed) {
        let oldState;
        if (seed !== undefined) {
            if (cleverapps.config.debugMode) {
                console.warn("replace occurrence with PseudoRandom.GET(channel)");
                console.warn(new Error().stack);
            }
            oldState = this.state;
            this.seed(seed !== false ? seed : Math.floor(Math.random() * 1000000));
        }

        const res = [...arr];
        for (let i = res.length - 1; i > 0; i--) {
            const j = Math.floor(this.nextDouble() * (i + 1));
            [res[i], res[j]] = [res[j], res[i]];
        }

        if (oldState !== undefined) {
            this.seed(oldState);
        }

        return res;
    }

    nextInt() {
        this.state = (this.a * this.state + this.c) % this.m;
        return this.state;
    }

    nextDouble() {
        return this.nextInt() / this.m;
    }

    mathChoose(array) {
        if (array.length === 0) {
            return;
        }

        const s = Math.floor(Math.random() * array.length);
        return array[s];
    }

    chooseN(array, amount, seed) {
        const chosen = [];

        let oldState;
        if (seed !== undefined) {
            if (cleverapps.config.debugMode) {
                console.warn("replace occurrence with PseudoRandom.GET(channel)");
                console.warn(new Error().stack);
            }
            oldState = this.state;
            this.seed(seed !== false ? seed : Math.floor(Math.random() * 1000000));
        }

        for (let i = 0; i < amount && array.length; i++) {
            const item = this.choose(array);
            chosen.push(item);
            array.splice(array.indexOf(item), 1);
        }

        if (oldState !== undefined) {
            this.seed(oldState);
        }

        return chosen;
    }

    choose(array, seed) {
        if (array.length === 0) {
            return;
        }

        const s = this.random(0, array.length - 1, seed);
        return array[s];
    }

    probability(n, p, units) {
        if (Array.isArray(n)) {
            n = this.random(n[0], n[1]);
        }

        if (p.length < units.length) {
            const rem = units.length - p.length;

            let cur = 0;
            for (let t = 0; t < p.length; t++) {
                cur += p[t];
            }

            for (let i = 0; i < rem; i++) {
                p.push((1 - cur) / rem);
            }
        }

        const indexes = [];
        for (let j = 0; j < n; j++) {
            const item = this.pickOne(p);
            if (item !== undefined) {
                indexes.push(item);
            }
        }

        indexes.sort();

        return indexes.map((index) => units[index]);
    }

    pickOne(p) {
        let flipCoin = this.nextDouble();
        for (let k = 0; k < p.length; k++) {
            flipCoin -= p[k];
            if (flipCoin < 0) {
                return k;
            }
        }
    }

    random(start, end, seed) {
        let oldState;
        if (seed !== undefined) {
            if (cleverapps.config.debugMode) {
                console.warn("replace occurrence with PseudoRandom.GET(channel)");
                console.warn(new Error().stack);
            }
            oldState = this.state;
            this.seed(seed !== false ? seed : Math.floor(Math.random() * 1000000));
        }

        if (end === undefined) {
            end = start - 1;
            start = 0;
        }
        const rangeSize = end - start + 1;
        const result = start + Math.floor(this.nextDouble() * rangeSize);

        if (oldState !== undefined) {
            this.seed(oldState);
        }

        return result;
    }
}

PseudoRandom.CHANNELS = new Map();

if (typeof cc === "undefined") {
    module.exports = PseudoRandom;
}